import React from 'react';
import DesktopItem from '../Item';
import numeral from 'numeral';
import styled from '@emotion/styled';
import DisplayMoreWrapper from '../../../common/DisplayMoreWrapper';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  padding-bottom: 5px !important;

  .more-btn {
    border-bottom: 1px solid #dee2e6;
    border-top: none;
  }

  .add-attribute {
    cursor: pointer;
  }

  .add-order {
    color: #7e57c2;
    cursor: pointer;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    top: 0px;
    left: 0px;
    transform: translate3d(0px, 35px, 0px);
    .dropdown-item {
      cursor: pointer;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .head-row {
    padding: 0 16px 16px;
    border-bottom: 2px solid #f2f5f7;
    display: flex;
    flex-wrap: nowrap;

    .btn-group-left {
      margin-left: auto;
    }
  }
  .dropdown-menu {
    right: 0px;
    left: auto;
  }
  .btn {
    margin-bottom: 10px;
  }

  .main-item {
    display: grid;
    padding: 16px;
    border-bottom: 2px solid #f2f5f7;
    display: flex;
    .editable {
      height: 16px;
    }

    .image-wrapper {
      flex: 0 0 36px;
      height: 36px;
      margin-right: 16px;

      .image-td {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
      }
    }

    .data-wrapper {
      flex-grow: 1;

      .content-sum-wrapper {
        display: flex;

        .content-wrapper {
          flex-grow: 1;
          padding-right: 30px;

          .item-name {
            color: inherit;
            font-weight: 600;
          }

          .item-article {
            font-size: 11px;
          }

          .item-subname {
            font-size: 11px;
            color: #98a6ad;
            margin-bottom: 4px;

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }

        .sum-wrapper {
          flex: 0 0 87px;
          color: #7e2199;
        }
      }

      .item-status {
        font-size: 10px;
        text-transform: uppercase;
        padding: 8px 0 0;

        &.item-status-green {
          color: #1abc9c;
        }

        &.item-status-red {
          color: #f1556c;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: calc(100% + 16px);
            border-top: 1px solid #f2f5f7;
          }
        }

        span {
          display: block;
          text-transform: none;
          color: #98a6ad;
        }
      }

      .quantity {
        font-size: 11px;
        color: #98a6ad;
        text-transform: none;
        display: flex;
        line-height: 16px;
        padding-bottom: 8px;

        .item-price-quantity {
          margin: 0 3px;
          line-height: 16px;
        }
      }
    }

    .item-subtitle {
      color: #98a6ad;
      font-size: 11px;
      font-weight: normal;
      text-transform: uppercase;
    }
  }

  .items {
    padding: 0 !important;
  }

  .bottom-block {
    padding: 0 !important;
  }

  .list-edits-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 2px solid #f2f5f7;

    .add-item {
      color: #7e57c2;
    }

    .refresh-reserve {
      color: #f772a7;
      &.disabled {
        color: #7b7a7a;
        cursor: initital;
      }
    }
  }

  .totals {
    padding: 16px;
  }
`;

const MobileLayout = (props) => {
  const {
    orderSaved,
    currentSupply,
    isManualSupply,
    handleConfirmSupply,
    handleConfirmSupplyDifference,
    handleCmpletedSupply,
    isSupplyClosed,
    handleReturnToCompletionSupply,
    setShowDropdown,
    showDropdown,
    setShowActions,
    handleExportSupply,
    handleImportItems,
    showActions,
    handleSetFactToPlanQuantity,
    currentWarehouse,
    setQuantityFactChange,
    handleAddItemsManually,
    total,
    handleEditSupplyOrder,
    defaultReserve,
    hasRelatedOrder,
  } = props;

  const { t } = useAutoTranslation();

  return (
    <Wrapper className="card-box">
      <div className="row head-row">
        <div className="col-12 text-right">
          {orderSaved && currentSupply.status === 'NEW' && !isManualSupply ? (
            <button className="btn btn-warning" onClick={handleConfirmSupply}>
              Подтвердить
            </button>
          ) : null}
          {orderSaved && currentSupply.status === 'DIFFERENCE' ? (
            <button className="btn btn-warning" onClick={handleConfirmSupplyDifference}>
              Подтвердить расхождения
            </button>
          ) : null}
          {orderSaved &&
          isManualSupply &&
          (currentSupply.status === 'NEW' ||
            currentSupply.status === 'READY_TO_TAKE_IN' ||
            currentSupply.status === 'TAKE_IN_PROCESS') ? (
            <button className="btn btn-success" onClick={handleCmpletedSupply}>
              Поставка принята
            </button>
          ) : null}
          {orderSaved && isManualSupply && isSupplyClosed ? (
            <button className="btn btn-secondary" onClick={handleReturnToCompletionSupply}>
              <i className="fe-corner-up-left"></i> Возврат на приемку
            </button>
          ) : null}
          <div
            style={{
              position: `relative`,
              marginLeft: `auto`,
              display: `inline-block`,
            }}
          >
            {currentSupply.status === 'COMPLETED' ||
            currentSupply.status === 'COMPLETED_WITH_DIFFERENCE' ||
            currentSupply.status === 'DIFFERENCE' ? (
              <>
                <button
                  type="button"
                  className="btn btn-light dropdown-toggle ml-1"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <>
                    Действия
                    <i className="mdi mdi-chevron-down" />
                  </>
                </button>
                <div
                  className={`dropdown-menu ${showDropdown ? `show` : ``}`}
                  onClick={() => setShowActions(false)}
                >
                  <div className="dropdown-item" onClick={handleExportSupply}>
                    <i className="" />
                    Выгрузить отчёт по приёмке
                  </div>
                </div>
              </>
            ) : null}
          </div>

          {!isSupplyClosed ? (
            <button className="btn btn-light ml-1" onClick={handleImportItems}>
              <i className="fe-arrow-up" />
              Импорт из Excel
            </button>
          ) : null}

          <div className={`btn-group ml-1 ${showActions ? 'show' : ''}`}>
            <button
              type="button"
              className="btn btn-light dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => setShowActions(!showActions)}
            >
              Действия
              <i className="mdi mdi-chevron-down" />
            </button>
            <div
              className={`dropdown-menu ${showActions ? 'show' : ''}`}
              x-placement="bottom-start"
              onClick={() => setShowActions(false)}
            >
              {orderSaved &&
              isManualSupply &&
              (currentSupply.status === 'NEW' ||
                currentSupply.status === 'READY_TO_TAKE_IN' ||
                currentSupply.status === 'TAKE_IN_PROCESS') ? (
                <div className="dropdown-item" onClick={handleSetFactToPlanQuantity}>
                  Заполнить по плану
                </div>
              ) : null}
              <div className="dropdown-item" onClick={handleExportSupply}>
                <i className="" />
                Выгрузить отчёт по приёмке
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="items">
        {currentSupply ? (
          <DisplayMoreWrapper array={currentSupply.planItems} btnClassName="more-btn">
            {({ item, itemIndex }) => (
              <DesktopItem
                key={`${item.productId}=${item.variantId}`}
                item={item}
                itemIndex={itemIndex}
                currentWarehouse={currentWarehouse}
                setQuantityFactChange={setQuantityFactChange}
                handleEditSupplyOrder={handleEditSupplyOrder}
                defaultReserve={defaultReserve}
                hasRelatedOrder={hasRelatedOrder}
              />
            )}
          </DisplayMoreWrapper>
        ) : null}
      </div>
      <div className="bottom-block">
        <div className="list-edits-wrapper">
          {!isSupplyClosed ? (
            <div className="add-item" onClick={handleAddItemsManually}>
              + Новая позиция
            </div>
          ) : null}
        </div>
        <div className="totals" style={{ paddingRight: 0 }}>
          <div className="items-total text-lg-right">
            <div>Сумма: {numeral(total.totalOrderSum).format('0,0.00')}</div>
            <div>В том числе НДС: {numeral(total.totalVat).format('0,0.00')}</div>

            {total.factTotalQuantity ? (
              <>
                <div className="mt-2">
                  <strong>Фактически принято:</strong>
                </div>
                <div>
                  {t('Сумма')}: {numeral(total.factTotalOrderSum).format('0,0.00')}
                </div>
                <div>
                  {t('В том числе НДС')}: {numeral(total.factTotalVat).format('0,0.00')}
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default MobileLayout;
